<template>
    <Page :showBackButton="true">
        <contract-card :contractId="contractId"></contract-card>
        <expansion-card v-if="teilentnahmeInfo !== ''">
            <template v-slot:header>
                <b>Wichtiger Hinweis</b>
            </template>
            <div v-html="teilentnahmeInfo"></div>
        </expansion-card>
        <h2>Auszahlung</h2>
        <b
            >Falls du kurzfristig Geld benötigst, kannst du dir je Fonds bis zum
            möglichen Maximalbetrag, Geld auszahlen lassen.</b
        >
        <form @submit.prevent="submitForm()">
            <ion-grid class="ion-margin-top">
                <ion-row class="ion-align-items-center">
                    <ion-col size="5"></ion-col>
                    <ion-col size="4" class="ion-text-center">
                        Möglich
                    </ion-col>
                    <ion-col size="3">
                        Entnahme
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center" v-if="!isVollwert">
                    <ion-col size="5">
                        Klassische Lebens&shy;versicherung
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{ flexiblelife.klvmaxteilentnahmebetrag | currency }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="klassischteilentnahme"
                            v-model="flexiblelifeData.klassischteilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds1.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds1.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds1teilentnahme"
                            v-model="flexiblelifeData.fonds1teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds2.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds2.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds2teilentnahme"
                            v-model="flexiblelifeData.fonds2teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row
                    class="ion-align-items-center"
                    v-if="!isVollwert && !isFlexibleLife20"
                >
                    <ion-col size="5">
                        {{ flexiblelifeFonds7.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds7.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds7teilentnahme"
                            v-model="flexiblelifeData.fonds7teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds3.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds3.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds3teilentnahme"
                            v-model="flexiblelifeData.fonds3teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds4.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds4.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds4teilentnahme"
                            v-model="flexiblelifeData.fonds4teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds5.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds5.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds5teilentnahme"
                            v-model="flexiblelifeData.fonds5teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                    <ion-col size="5">
                        {{ flexiblelifeFonds6.name }}
                    </ion-col>
                    <ion-col size="4" class="ion-text-center">
                        {{
                            flexiblelifeFonds6.maxteilentnahmebetrag | currency
                        }}
                    </ion-col>
                    <ion-col size="3">
                        <base-number-input
                            id="fonds6teilentnahme"
                            v-model="flexiblelifeData.fonds6teilentnahme"
                        ></base-number-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        Entnahmesumme
                    </ion-col>
                    <ion-col size="auto">
                        <b>{{ entnahmeSum | currency }}</b>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        Maximaler Betrag
                    </ion-col>
                    <ion-col size="auto">
                        <b>{{
                            flexiblelife.maxteilentnahmebetrag | currency
                        }}</b>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <ion-button
                            @click="submitForm()"
                            expand="block"
                            :disabled="!(entnahmeSum > 0)"
                            >Entnehmen</ion-button
                        >
                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
    </Page>
</template>

<script>
import Page from "@/components/Page";
import { flexiblelife } from "@/mixins/flexiblelife";
import BaseNumberInput from "@/components/BaseNumberInput";
import ContractCard from "@/components/ContractCard";
import { parseValueToCurrency } from "@/utils/number";
// import { changeFlexibleLife } from "@/api/flexiblelife";
// import { changeVorsorge } from "@/api/vollwert";
import ExpansionCard from "@/components/ExpansionCard";
import MtanModal from "@/components/MtanModal";

export default {
    mixins: [flexiblelife],
    props: ["contractId"],
    components: {
        Page,
        BaseNumberInput,
        ContractCard,
        ExpansionCard,
    },
    data() {
        return {
            flexiblelifeData: {
                klassischteilentnahme: "",
                fonds1teilentnahme: "",
                fonds2teilentnahme: "",
                fonds7teilentnahme: "",
                fonds3teilentnahme: "",
                fonds4teilentnahme: "",
                fonds5teilentnahme: "",
                fonds6teilentnahme: "",
            },
        };
    },
    computed: {
        entnahmeSum() {
            var result = 0;
            for (let flexiblelifeDataKey in this.flexiblelifeData) {
                if (
                    flexiblelifeDataKey.includes("entnahme") &&
                    this.flexiblelifeData[flexiblelifeDataKey] !== ""
                ) {
                    result += parseFloat(
                        this.flexiblelifeData[flexiblelifeDataKey]
                    );
                }
            }
            return result;
        },
    },
    methods: {
        submitForm() {
            this.$ionic.alertController
                .create({
                    header: "Auszahlung",
                    message:
                        "Du möchtest dir " +
                        parseValueToCurrency(this.entnahmeSum) +
                        " auszahlen lassen. Der Betrag wird auf dein hinterlegtes Girokonto überwiesen. Die Entnahme ist KESt-frei. Wenn du auf „Durchführen“ klickst, erhältst du eine SMS mit einer mTAN, mit der du deine Änderung bestätigst.",
                    buttons: [
                        {
                            text: "Abbrechen",
                            role: "cancel",
                        },
                        {
                            text: "Durchführen",
                            handler: () => {
                                this.changeFlexibleLife();
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
        async changeFlexibleLife(verifymtan = false, mtan = "") {
            let data = Object.assign({}, this.flexiblelifeData);
            data.vertragsnummer = this.contractId;
            data.methode = "teilentnahme";
            data.simulate = false;
            data.verifymtan = verifymtan;
            data.mtan = mtan;
            this.$store.commit("setLoading", true);
            let changeFunctionName = "changeFlexibleLife";
            if (this.isVollwert) {
                changeFunctionName = "changeVorsorge";
                delete data.klassischteilentnahme;
                delete data.fonds7teilentnahme;
            } else if (this.isFlexibleLife20) {
                changeFunctionName = "changeFlexibleLife20";
                delete data.fonds7teilentnahme;
            }
            let api = await import("../api/" + this.vorsorgeText + ".js");
            api[changeFunctionName](data).then((response) => {
                if (response.data.Status === 200) {
                    if ("mtansend" in response.data.Result) {
                        this.$ionic.modalController
                            .create({
                                component: MtanModal,
                                backdropDismiss: false,
                                componentProps: {
                                    propsData: {
                                        mtansend: response.data.Result.mtansend,
                                        submitFunctionName:
                                            "changeFlexibleLife",
                                    },
                                    parent: this,
                                },
                            })
                            .then((m) => m.present());
                    } else {
                        this.$ionic.modalController.dismiss();
                        this.$ionic.alertController
                            .create({
                                header: "mTAN Bestätigung",
                                message:
                                    "Der Betrag von " +
                                    parseValueToCurrency(this.entnahmeSum) +
                                    " wird deinem hinterlegtem Girokonto gutgeschrieben.",
                                buttons: ["Ok"],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$router.go(-1);
                                    this.$store.commit("setAskForRating", true);
                                });
                                a.present();
                            });
                    }
                }
            });
        },
    },
};
</script>

<style></style>
